
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import {
  getProductAccountList,
  getProductInfo
} from '@/api/product/productAccount'
import { setProductInfo } from '@/api/product/product'

@Component({
  name: 'RMQRExtra',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) private product!: any
  @Prop({ required: true }) private code!: any

  private extraParam: any = {
    rhb_plugin_switch: 0,
    rhb_plugin_path: [
      {
        domain: '',
        count: '0'
      }
    ],
    floating_amount: null,
    // blocked_accounts: ['']
  }
  private flag: boolean = false
  private activeName: string = '1'
  private dataList: any[] = []
  private total: number = 0
  private listLoading: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back() {
    this.$emit('close', false)
  }
  private addMc() {
    this.extraParam.rhb_plugin_path.push({ domain: '', count: '0' })
  }

  // private addBan() {
  //   // 确保数组存在
  //   if (!this.extraParam.blocked_accounts) {
  //     this.extraParam.blocked_accounts = ['']
  //   }
  //   this.extraParam.blocked_accounts.push('')
  // }

  private handleClick(tab, event) {
    this.activeName = '1'
    if (tab.name === '2') {
      this.getProductInfo()
    }
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.getProductInfo()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.getProductInfo()
  }

  // 获取当前产品账户
  private async getProductInfo() {
    this.listLoading = true
    const data = {
      currency: 'RM',
      account_type: 'rhb_plugin',
      page_size: this.pagesize,
      page: this.currentPage
    }
    await getProductAccountList(data).then((res: any) => {
      this.total = res.count
      this.dataList = res.results
      this.listLoading = false
    })
  }

  private removeMc(index: number) {
    this.extraParam.rhb_plugin_path.splice(index, 1)
  }

  // private removeBan(index: number) {
  //   this.extraParam.blocked_accounts.splice(index, 1)
  // }

  private async setExtraUpdate() {
    // 清空未输入
    this.extraParam.rhb_plugin_path = this.extraParam.rhb_plugin_path.filter(
      item => item.domain !== ''
    )
    this.flag = true
    const data: any = {
      id: this.product.id,
      extra_param: {
        rhb_plugin_switch: this.extraParam.rhb_plugin_switch,
        rhb_plugin_path: this.extraParam.rhb_plugin_path
      }
    }
    await setProductInfo(data).then(() => {
      this.$message({
        message: 'Edit success',
        type: 'success'
      })
      this.flagStr()
      this.back()
    })
  }

  // private async setBanAccount() {
  //   // 清空未输入
  //   this.extraParam.blocked_accounts = this.extraParam.blocked_accounts.filter(
  //     item => item !== ''
  //   )
  //   this.flag = true
  //   const data: any = {
  //     id: this.product.id,
  //     extra_param: {
  //       blocked_accounts: this.extraParam.blocked_accounts
  //     }
  //   }
  //   await setProductInfo(data).then(() => {
  //     this.$message({
  //       message: 'Edit success',
  //       type: 'success'
  //     })
  //     this.flagStr()
  //     this.back()
  //   })
  // }

  private async setFloatingAmount() {
    this.flag = true
    const data: any = {
      id: this.product.id,
      extra_param: {
        floating_amount: Number(this.extraParam.floating_amount)
      }
    }
    await setProductInfo(data).then(() => {
      this.$message({
        message: 'Edit success',
        type: 'success'
      })
      this.flagStr()
      this.back()
    })
  }

  // 产品详情
  private async getInfo() {
    const data = {
      id: this.product.id
    }
    await getProductInfo(data).then((res: any) => {
      if (
        res.extra_param.rhb_plugin_switch ||
        res.extra_param.rhb_plugin_path ||
        res.extra_param.floating_amount 
      ) {
        this.extraParam = {
          rhb_plugin_switch: res.extra_param.rhb_plugin_switch,
          rhb_plugin_path: res.extra_param.rhb_plugin_path,
          floating_amount: res.extra_param.floating_amount,
        }
      } else {
        this.extraParam = {
          rhb_plugin_switch: 0,
          rhb_plugin_path: [{ domain: '', count: '0' }],
          floating_amount: null,
        }
      }
    })
  }

  mounted() {
    this.getInfo()
  }
}
